import { faMessage, faPhone } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import './Delivery_Partner.css'

const Delivery_Partner = ({ delivery_boy }) => {
    return (
        <div className='delivery_partner_div'>
            <div className='left_side_div'>
                <div className='img_holder'>
                    <img
                        src={
                            process.env.REACT_APP_IMG_URL +
                            delivery_boy?.image
                        }
                    />
                </div>

                <h3 className='delivery_boy_name'>{delivery_boy?.name} is delivery partner</h3>

            </div>

            <div className='contact_icon_holder'>
                <div className='icon_holder'>
                    <FontAwesomeIcon icon={faMessage} className='message_icon' />
                </div>

                <div className='icon_holder'>
                    <FontAwesomeIcon icon={faPhone} className='message_icon' />
                </div>
            </div>

        </div>
    )
}

export default Delivery_Partner
